import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

let uniqueCheckboxId = 0;
@Component({
  selector: 'afp-checkbox',
  templateUrl: './checkbox.html',
  styleUrls: ['./checkbox.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CheckboxComponent), multi: true }
  ]
})
export class CheckboxComponent implements ControlValueAccessor, OnInit, Validator, OnChanges {
  @Input() set id(value: string | undefined) {
    if (value) this.inputId = value;
  }
  @Input() name?: string;
  @Input() checked = false;
  @Input() disabled = false;
  @Input() required = false;
  @Output() change = new EventEmitter<boolean>();

  public inputId = `afp-checkbox-${uniqueCheckboxId++}`;

  onChange: (_: boolean) => void = () => {};
  onTouch: () => void = () => {};
  private validatorChange?: () => void;

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('checked' in changes && !changes['checked'].firstChange) {
      this.writeValue(changes['checked'].currentValue);
      this.validatorChange?.();
    }
    if ('required' in changes && !changes['required'].firstChange) {
      this.validatorChange?.();
    }
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }

  registerOnChange(onChange: (_: boolean) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouch: () => void): void {
    this.onTouch = onTouch;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.required) return null;
    return control.value === true ? null : { required: true };
  }

  registerOnValidatorChange(validationChange: () => void): void {
    this.validatorChange = validationChange;
  }

  toggle(): void {
    if (this.disabled) return;
    this.checked = !this.checked;
    this.onChange(this.checked);
    this.onTouch();
    this.change.emit(this.checked);
  }

  onNativeChange(event: Event): void {
    if (this.disabled) return;
    const next = (event.target as HTMLInputElement).checked;
    this.checked = next;
    this.onChange(next);
    this.change.emit(next);
  }

  onBlur(): void {
    this.onTouch();
  }
}
